import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { NgxDynamicDashboardModule } from '@mare-common/ngx-dynamic-dashboard';
import { PlotlyViaWindowModule, PlotlyService } from 'angular-plotly.js';
import * as Italianlocale from 'plotly.js-locales/it';


@NgModule({
  declarations: [
    
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    TranslateModule,
    PlotlyViaWindowModule,
    NgxDynamicDashboardModule
  ],
  exports: [
  ]
})
export class CompanyIdentityComponentsModule {
  constructor(private plotlyService: PlotlyService) {
    this._setUpPlotlyWithLocaleIt();
  }
  private async _setUpPlotlyWithLocaleIt() {
    const plotly = await this.plotlyService.getPlotly();
    if (!plotly || plotly == 'waiting') {
      setTimeout(() => {
        this._setUpPlotlyWithLocaleIt();
      }, 100);
      return;
    }
    plotly.register(Italianlocale);
    plotly.setPlotConfig({locale: 'it-IT'})
  }
 }
